import request from '@/utils/request'

let Ma_hzd_inv_infoApi = {

  /*隐患排查信息 列表*/
  list(data) {
    return request._post('/shop/plus.ma_hzd_inv_info.Index/index', data);
},
/*添加隐患排查信息 */
add(data) {
    return request._post('/shop/plus.ma_hzd_inv_info.Index/add', data);
},
/*修改隐患排查信息 */
edit(data) {
    return request._post('/shop/plus.ma_hzd_inv_info.Index/edit', data);
},
/*删除隐患排查信息 */
del(data) {
    return request._post('/shop/plus.ma_hzd_inv_info.Index/del', data);
},
/*隐患排查信息 详情*/
detail(data) {
  return request._post('/shop/plus.ma_hzd_inv_info.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.ma_hzd_inv_info.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.ma_hzd_inv_info.Setting/getSetting', data, errorback);
    },

    importData(data) {
        return request._post('/shop/plus.ma_hzd_inv_info.Index/import', data);
    },
    exportExcel(data) {
        return request._post('/shop/plus.ma_hzd_inv_info.Index/export', data);
    },
}
export default Ma_hzd_inv_infoApi;



// WEBPACK FOOTER //
// ./src/api/ma_hzd_inv_info.js